import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Star = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      clipRule="evenodd"
      d="M12 4.73595L9.66317 9.40963L4.60252 10.1882L8.06066 13.6463L7.25986 19.2519L12 16.8819L16.7401 19.2519L15.9393 13.6463L19.3975 10.1882L14.3368 9.40963L12 4.73595ZM10.6584 2.9471C11.2111 1.84153 12.7889 1.84153 13.3416 2.9471L15.6632 7.59015L20.6768 8.36148C21.8912 8.54831 22.3782 10.0359 21.5094 10.9047L18.0607 14.3534L18.855 19.9138C19.0261 21.1116 17.7815 22.0087 16.6992 21.4675L12 19.1179L7.30075 21.4675C6.2185 22.0087 4.97389 21.1116 5.14501 19.9138L5.93934 14.3534L2.4906 10.9047C1.62181 10.0359 2.10881 8.5483 3.32317 8.36148L8.33684 7.59015L10.6584 2.9471Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Star;
